/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react-native/no-inline-styles */
/**
 * MyAccount Screen
 *
 * Account settings and navigation hub
 * Displays menu items for:
 * - Profile
 * - Change Password
 * - Orders
 * - Sales Report
 * - Item Wise Report
 * - Item Wise Stock Report
 * - Counters Report
 * - Logout
 * - App version (non-web only)
 *
 * @component
 * @param {Object} navigation - React Navigation object
 */
import React, { useEffect, useState } from 'react';
import {
  FlatList,
  InteractionManager,
  Platform,
  StyleSheet,
  View,
} from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { List, Text } from 'react-native-paper';
import { theme } from '../theme/theme';
import { useDispatch, useSelector } from 'react-redux';
import { showLogoutAlert } from '../store/customer.slice';
import environment from '../environment';
import { getVersion } from 'react-native-device-info';

function MyAccount({ navigation }) {
  const dispatch = useDispatch();
  const app_version = getVersion();
  const customer = useSelector(state => state.customer?.customer);
  const [interactionCompleted, setIntersectionCompleted] = useState(false);
  const customer_settings = customer?.customer_settings;

  useEffect(() => {
    const task = InteractionManager.runAfterInteractions(async () => {
      setIntersectionCompleted(true);
    });
    return () => {
      task.cancel();
    };
  }, []);

  const logoutHandler = () => {
    dispatch(showLogoutAlert());
  };

  const renderItem = ({ item, index }) => {
    return (
      <View style={{ backgroundColor: '#ffffff', borderRadius: 16 }}>
        <List.Item
          title="Profile"
          onPress={() => navigation.push('Profile')}
          titleStyle={styles.titleStyle}
          right={props => (
            <List.Icon {...props} color="#dddddd" icon="chevron-right" />
          )}
        />
        <List.Item
          title="Change Password"
          onPress={() => navigation.push('ChangePassword')}
          titleStyle={styles.titleStyle}
          right={props => (
            <List.Icon {...props} color="#dddddd" icon="chevron-right" />
          )}
        />
        <List.Item
          title="Orders"
          onPress={() => navigation.push('Orders')}
          titleStyle={styles.titleStyle}
          right={props => (
            <List.Icon {...props} color="#dddddd" icon="chevron-right" />
          )}
        />
        {customer_settings?.show_sales_report && <List.Item
          onPress={() => navigation.push('SalesReport')}
          title="Sales Report"
          titleStyle={styles.titleStyle}
          right={props => (
            <List.Icon {...props} color="#dddddd" icon="chevron-right" />
          )}
        />}
        {customer_settings?.show_item_wise_report && <List.Item
          onPress={() => navigation.push('ItemWiseReport')}
          title="Item Wise Report"
          titleStyle={styles.titleStyle}
          right={props => (
            <List.Icon {...props} color="#dddddd" icon="chevron-right" />
          )}
        />}
        {customer_settings?.show_item_wise_stock_report && <List.Item
          onPress={() => navigation.push('ItemWiseStockReport')}
          title="Item Wise Stock Report"
          titleStyle={styles.titleStyle}
          right={props => (
            <List.Icon {...props} color="#dddddd" icon="chevron-right" />
          )}
        />}
        {customer_settings?.show_counter_report && <List.Item
          onPress={() => navigation.push('CountersReport')}
          title="Counters Report"
          titleStyle={styles.titleStyle}
          right={props => (
            <List.Icon {...props} color="#dddddd" icon="chevron-right" />
          )}
        />}
        {/* <List.Item title="FAQs" titleStyle={styles.titleStyle} onPress={() => openURL(environment.BASE_URL + '/faqs')} />
                <List.Item title="Privacy Policy" titleStyle={styles.titleStyle} onPress={() => openURL(environment.BASE_URL + '/privacy-policy')} />
                <List.Item title="Terms and Conditions" titleStyle={styles.titleStyle} onPress={() => openURL(environment.BASE_URL + '/terms-conditions')} />
                <List.Item title="Contact US" titleStyle={styles.titleStyle} onPress={() => openURL(environment.BASE_URL + '/contact-us')} />
                <List.Item title="Cancellation Policy" titleStyle={styles.titleStyle} onPress={() => openURL(environment.BASE_URL + '/cancellation-policy')} /> */}
        <List.Item
          title="Logout"
          onPress={logoutHandler}
          titleStyle={styles.titleStyle}
          right={props => (
            <List.Icon {...props} color="#dddddd" icon="chevron-right" />
          )}
        />
        {/* {Platform.OS !== 'web' && <List.Item title={`Version: ${getVersion()} (${environment.ENV})`} titleStyle={styles.titleStyle} />} */}
      </View>
    );
  };

  return (
    <SafeAreaView
      edges={['bottom']}
      style={[styles.container, { backgroundColor: theme.colors.primary }]}>
      {interactionCompleted && (
        <React.Fragment>
          <View style={styles.mainContainer}>
            <FlatList data={['customer']} renderItem={renderItem} />
            {Platform.OS !== 'web' && (
              <View style={styles.versionContainer}>
                <Text style={styles.versionTitle}>App Version</Text>
                <Text style={styles.versionNumber}>{app_version}</Text>
                {/* <Text style={styles.versionEnv}>{environment.ENV}</Text> */}
              </View>
            )}
          </View>
        </React.Fragment>
      )}
    </SafeAreaView>
  );
}

const styles = StyleSheet.create({
  container: {
    ...(Platform.OS === 'web' ? { flexGrow: 1 } : { flex: 1 }),
  },
  mainContainer: {
    flex: 1,
    borderRadius: 4,
    paddingBottom: 16,
    padding: 8,
    margin: 8,
  },
  scrollView: {
    flexGrow: 1,
    // borderRadius: 4,
    // backgroundColor: '#ffffff',
    paddingVertical: 8,
  },
  titleStyle: {
    fontSize: 14,
  },
  versionContainer: {
    alignItems: 'center',
    marginTop: '24',
    marginBottom: 4,
  },

  versionTitle: {
    fontSize: 18,
    color: '#fff',
  },

  versionNumber: {
    fontSize: 14,
    fontWeight: '600',
    color: '#b9b7b7ff',
    marginTop: 2,
  },

  versionEnv: {
    fontSize: 12,
    color: '#999',
    marginTop: 2,
  },
});

export default MyAccount;
